var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_991_1825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9994 57.6766C45.2845 57.6766 57.6756 45.2855 57.6756 30.0004C57.6756 14.7153 45.2845 2.32422 29.9994 2.32422C14.7143 2.32422 2.32324 14.7153 2.32324 30.0004C2.32324 45.2855 14.7143 57.6766 29.9994 57.6766Z",
    fill: "#1B2454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 60C13.4593 60 0 46.543 0 30C0 13.4593 13.4593 0 30 0C46.543 0 60 13.4593 60 30C60 46.543 46.543 60 30 60ZM30 4.64754C16.0201 4.64754 4.64754 16.0201 4.64754 30C4.64754 43.9799 16.0201 55.3525 30 55.3525C43.9799 55.3525 55.3525 43.9775 55.3525 30C55.3525 16.0201 43.9799 4.64754 30 4.64754Z",
    fill: "#1B2454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0006 43.7331C28.7179 43.7331 27.6768 42.6944 27.6768 41.4093V18.1715C27.6768 16.8888 28.7179 15.8477 30.0006 15.8477C31.2833 15.8477 32.3244 16.8888 32.3244 18.1715V41.4093C32.3244 42.6944 31.2833 43.7331 30.0006 43.7331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6193 32.1145H18.3814C17.0987 32.1145 16.0576 31.0734 16.0576 29.7906C16.0576 28.5079 17.0987 27.4668 18.3814 27.4668H41.6193C42.9043 27.4668 43.9431 28.5079 43.9431 29.7906C43.9431 31.0734 42.9043 32.1145 41.6193 32.1145Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_991_1825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.2b7e34c6c4973d0a4b02c671718891a5.svg";
export { ForwardRef as ReactComponent };